import React, { useState, useEffect, useRef } from "react";
import "../../css/CRUDModal.css";
import { ReactComponent as ChevronDownIcon } from "../../assets/Icons/Chevron down.svg";
import { ReactComponent as ChevronUp } from "../../assets/Icons/ChevronUp.svg";
import { axiosGetApi, axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import CustomAlert from "../../helpers/CustomAlert";
import { formatDateToYYYYMMDD } from "../../helpers/DateHelpers";
import { useDispatch } from "react-redux";
import { setBalance } from "../store/balance/balanceSlice";
import confetti from "canvas-confetti";

const BuySMSModal = ({
  show,
  handleClose,
  editData,
  action,
  data,
  fetchData,
}) => {
  const loggedInUserName = sessionStorage.getItem("username");
  const [customerNameOpen, setCustomerNameOpen] = useState(false);
  const [vendorList, setVendorList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const customerNameRef = useRef(null);
  const toggleCustomerNameDropdown = () =>
    setCustomerNameOpen(!customerNameOpen);
  const dispatch = useDispatch();

  const handleClickOutside = (event) => {
    if (
      customerNameRef.current &&
      !customerNameRef.current.contains(event.target)
    ) {
      setCustomerNameOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (action === "add") {
      fetchVendorData();
      setFormData({
        username: loggedInUserName,
        vendorName: "",
        smsBalance: "",
        currentRate: "",
        amount: "",
        smsToBeTopUp: "",
      });
    }
  }, [action]);

  const fetchVendorData = () => {
    axiosGetApi(apiList.ALL_ACTIVE_VENDOR_DATA)
      .then((response) => {
        if (response?.status === 200) {
          setVendorList(response?.data?.data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const [formData, setFormData] = useState({
    username: loggedInUserName,
    vendorName: "",
    smsBalance: "",
    lastTopUpDate: "",
    currentRate: "",
    amount: "",
    smsToBeTopUp: "",
  });

  const [errors, setErrors] = useState({
    vendorName: "",
    smsBalance: "",
    lastTopUpDate: "",
    currentRate: "",
    amount: "",
    smsToBeTopUp: "",
  });

  const handleInputChange = (e) => {
    const { id, value } = e.target;

    let updatedValue = value;

    if (id === "vendorName") {
      let vendorDetails = vendorList.filter(
        (row) => row.vendorName === value
      )?.[0];
      let tempFormData = {
        ...formData,
        [id]: value,
        ["smsBalance"]: vendorDetails?.smsBalance,
        ["lastTopUpDate"]: vendorDetails?.transactionDate,
        ["currentRate"]: vendorDetails?.rate || "",
        ["vendorId"]: vendorDetails?.vendorId,
        ["amount"]: "",
        ["smsToBeTopUp"]: "",
      };
      setFormData(tempFormData);
    } else if (id === "smsToBeTopUp") {
      if (!formData.vendorName || !formData.currentRate) {
        setErrors((prev) => ({
          ...prev,
          vendorName: "Please select a Vendor Name.",
        }));
        return;
      }

      updatedValue = value.replace(/[^0-9]/g, "");
      let topUpSMSValue = updatedValue * formData?.currentRate || "";
      setFormData({
        ...formData,
        [id]: updatedValue,
        ["amount"]: parseFloat(topUpSMSValue?.toFixed(2)),
      });
    } else {
      setFormData({ ...formData, [id]: updatedValue });
    }
  };

  const validate = () => {
    const newErrors = {};

    // Vendor Name Validation
    if (!formData.vendorName) {
      newErrors.vendorName = "Vendor Name is required";
    }

    // SMS To Be Top Up Validation
    if (!formData.smsToBeTopUp) {
      newErrors.smsToBeTopUp = "SMS To Be Top Up required";
    } else if (!/^\d{1,7}$/.test(formData.smsToBeTopUp)) {
      newErrors.smsToBeTopUp = "SMS must be maximum 7 digits";
    } else if (Number(formData.smsToBeTopUp) === 0) {
      newErrors.smsToBeTopUp = "SMS cannot be 0";
    }

    return newErrors;
  };

  const fetchDashboardData = () => {
    const endDate = formatDateToYYYYMMDD(new Date());
    const startDate1 = new Date(new Date().setDate(new Date().getDate() - 90));
    const finalStartDate = formatDateToYYYYMMDD(startDate1);

    const requestBody = {
      startDate: finalStartDate,
      endDate: endDate,
      username: loggedInUserName,
    };

    axiosPostApi(apiList.DASHBOARD_DATA, requestBody)
      .then((response) => {
        if (response?.status === 200 && response?.data?.respCode === "00") {
          dispatch(setBalance(response?.data?.data?.balanceDetails));
          fetchData(1);
        } else {
          // Handle error case here if necessary
        }
      })
      .catch((error) => {
        console.error("Error fetching SMS overview data", error);
      });
  };

  const handleBuySMS = () => {
    const validationErrors = validate();
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      setIsSubmitted(true);
      let apiUrl = "";
      let successMessage = "";

      if (action === "add") {
        apiUrl = apiList.CREATE_BUYSMS_DATA;
        successMessage = "SMS buy successfully";
      }

      axiosPostApi(apiUrl, formData)
        .then((response) => {
          if (response?.status === 200 && response?.data?.status === true) {
            CustomAlert({
              title: action === "add" ? "SMS buy successfully." : "",
              text: response.data.message,
              icon: "success",
              confirmButtonText: "Ok",
              showCloseButton: true,
              allowOutsideClick: false,
            }).then((result) => {
              if (result.isConfirmed) {
                fetchDashboardData();
              }
            });
            // Add confetti effect
            const canvas = document.createElement("canvas");
            canvas.style.position = "fixed";
            canvas.style.top = "0";
            canvas.style.left = "0";
            canvas.style.width = "100%";
            canvas.style.height = "100%";
            canvas.style.zIndex = "3000";
            document.body.appendChild(canvas);

            const confettiInstance = confetti.create(canvas, {
              resize: true,
              useWorker: true,
            });

            confettiInstance({
              particleCount: 250,
              spread: 100,
              origin: { y: 0.6 },
            });

            setTimeout(() => {
              document.body.removeChild(canvas);
            }, 3000);
            handleClose();
          }
          if (response?.data?.respCode === "02") {
            CustomAlert({
              title: "Warning",
              text:
                response?.data?.message || "Unable to proceed, check Balance",
              icon: "warning",
              confirmButtonText: "Okay",
            });
          }
        })
        .catch((error) => {
          console.error("Error processing customer request:", error);
          CustomAlert({
            title: "Error",
            text: "An error occurred while adding the Buy SMS. Please try again later.",
            icon: "error",
            confirmButtonText: "Retry",
          });
        });
    }
  };

  const handleBack = () => {
    handleClose();
    setErrors({});
    setFormData({
      username: loggedInUserName,
      vendorName: "",
      smsBalance: "",
      lastTopUpDate: "",
      currentRate: "",
      amount: "",
      smsToBeTopUp: "",
    });
  };

  return (
    <>
      <div
        className={`modal-lg modal fade ${show ? "show" : ""}`}
        tabIndex="-1"
        role="dialog"
        style={{ display: show ? "block" : "none" }}
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title main-title">Buy SMS Details</h5>
            </div>
            <div className="scoped-modal modal-body">
              <form>
                <div className="row mb-3">
                  <div className="col-md-4">
                    <label htmlFor="vendorName">
                      Vendor Name<span style={{ color: "red" }}>*</span>
                    </label>
                    <div
                      className="form-group position-relative"
                      ref={customerNameRef}
                    >
                      <select
                        className="form-control select-dropdown"
                        id="vendorName"
                        placeholder="Role"
                        value={formData.vendorName}
                        onClick={toggleCustomerNameDropdown}
                        onChange={handleInputChange}
                      >
                        <option value="" disabled selected>
                          Select Vendor Name
                        </option>
                        {vendorList?.map((vendor) => {
                          return <option>{vendor.vendorName}</option>;
                        })}
                      </select>
                      <span className="position-absolute select-icon">
                        {customerNameOpen ? <ChevronUp /> : <ChevronDownIcon />}
                      </span>
                    </div>
                    {errors.vendorName ? (
                      <span className="error">{errors.vendorName}</span>
                    ) : null}
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="smsBalance">SMS Balance</label>
                      <input
                        type="text"
                        className="form-control"
                        id="smsBalance"
                        placeholder="SMS Balance"
                        value={formData.smsBalance}
                        onChange={handleInputChange}
                        style={{ textAlign: "right", cursor: "not-allowed" }}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="currentRate">Current Rate</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Current Rate"
                      value={formData.currentRate}
                      id="currentRate"
                      style={{ textAlign: "right", cursor: "not-allowed" }}
                      onChange={handleInputChange}
                      readOnly
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="smsToBeTopUp">
                        SMS to be Top-Up<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={formData?.smsToBeTopUp}
                        id="smsToBeTopUp"
                        placeholder="SMS to be Top-Up"
                        onChange={handleInputChange}
                        style={{ textAlign: "right" }}
                        // readOnly
                      />
                      {errors.smsToBeTopUp ? (
                        <span className="error">{errors.smsToBeTopUp}</span>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="amount">Amount to be Top-Up</label>
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        value={formData.amount}
                        id="amount"
                        placeholder="Enter Amount"
                        style={{ textAlign: "right", cursor: "not-allowed" }}
                        onChange={handleInputChange}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div className="scoped-modal modal-footer">
              <button
                type="button"
                className="btn btn-back"
                onClick={handleBack}
              >
                Back
              </button>
              <button
                type="button"
                className="btn btn-submit"
                onClick={handleBuySMS}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
      {show && <div className="modal-backdrop fade show"></div>}
    </>
  );
};

export default BuySMSModal;
